import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import styles from './mobile_menu.module.css';

export default function MobileMenu({ visible = true, dark = false }) {
    const [open, setOpen] = useState(false);
    const button = useRef(null);
    const location = useLocation();
    const close = () => setOpen(false);
    useEffect(() => { setOpen(false); }, [location.pathname, visible]);
    useEffect(() => {
        const escape = event => {
            if (event.key === 'Escape') { setOpen(false); button.current?.focus(); }
        };
        const desktop = window.matchMedia('(min-width: 1024px)');
        const resize = () => { if (desktop.matches) setOpen(false); };
        if (open) document.addEventListener('keydown', escape);
        desktop.addEventListener('change', resize);
        return () => { document.removeEventListener('keydown', escape); desktop.removeEventListener('change', resize); };
    }, [open]);
    if (!visible) return null;
    return <div className={`${styles.root} ${dark ? styles.dark : ''}`}>
        <button ref={button} className={styles.toggle} type="button" aria-label={open ? '메뉴 닫기' : '메뉴 열기'} aria-expanded={open} aria-controls="site-mobile-menu" onClick={() => setOpen(value => !value)}>
            <FontAwesomeIcon icon={open ? faTimes : faBars} aria-hidden="true" />
        </button>
        {open && <nav id="site-mobile-menu" className={styles.menu} aria-label="모바일 메뉴">
            <Link to="/" onClick={close}>홈</Link>
            <Link to="/company" onClick={close}>회사소개</Link>
            <Link to="/portfolio" onClick={close}>사업영역 · 프로젝트</Link>
            <Link to="/hashtag" onClick={close}>사업영역 · 해시태그</Link>
            <Link to="/services" onClick={close}>서비스</Link>
            <Link to="/education" onClick={close}>교육·강의</Link>
        </nav>}
    </div>;
}
